import React from "react";
import { object, bool } from "prop-types";
import { Link } from "@quintype/components";

import "./linkView.m.css";

const LinkView = ({ item, isSelected = false }) => {
  if (item["section-slug"]) {
    return (
      <Link href={`/${item["section-slug"]}`} styleName={isSelected ? "selected-item" : ""}>
        {item.title}
      </Link>
    );
  }

  if (item["tag-slug"]) {
    return (
      <Link href={`/${item["tag-slug"]}`} styleName={isSelected ? "selected-item" : ""}>
        {item.title}
      </Link>
    );
  }

  return (
    <a href={item.completeUrl} styleName={isSelected ? "selected-item" : ""}>
      {item.title}
    </a>
  );
};

LinkView.propTypes = {
  item: object.isRequired,
  isSelected: bool,
};

export default LinkView;
